import { ref } from 'vue'
import api from '@/utils/api'

const settingsCache = ref(null)
const isLoading = ref(false)
let pendingRequest = null

const normalizeLocale = (locale) => {
  if (locale === 'kz' || locale === 'en') {
    return locale
  }
  return 'ru'
}

const fetchSettings = async () => {
  if (settingsCache.value) {
    return settingsCache.value
  }

  if (pendingRequest) {
    return pendingRequest
  }

  isLoading.value = true
  pendingRequest = api
    .get('/public/settings')
    .then((response) => {
      settingsCache.value = response.data || {}
      return settingsCache.value
    })
    .catch((error) => {
      settingsCache.value = settingsCache.value || {}
      throw error
    })
    .finally(() => {
      isLoading.value = false
      pendingRequest = null
    })

  return pendingRequest
}

const getSetting = (key) => {
  return settingsCache.value?.[key]
}

const getLocalizedSetting = (key, locale, fallback = '') => {
  const setting = getSetting(key)
  if (!setting) {
    return fallback
  }

  const localeKey = normalizeLocale(locale)
  return setting[localeKey] || setting.kz || setting.ru || setting.en || fallback
}

const refreshSettings = async () => {
  settingsCache.value = null
  return fetchSettings()
}

export const usePublicSettings = () => ({
  settings: settingsCache,
  loading: isLoading,
  loadSettings: fetchSettings,
  refreshSettings,
  getSetting,
  getLocalizedSetting
})
